import DevPasswordGate from './components/DevPasswordGate';
import AppPage from './pages/AppPage';

function App() {
  return (
    <DevPasswordGate>
      <AppPage />
    </DevPasswordGate>
  );
}

export default App;
